// polyfills
import 'babel-polyfill'
import 'intersection-observer'
import smoothscroll from 'smoothscroll-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'
import './validation'
import {} from 'normalize.css'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import VueQuammServices from 'quamm-client-vue/src/index'

if (process.env.NODE_ENV === 'production') {
  Raven
    .config('https://0b979a1fde924155980d2dba7fe0be69@sentry.quamm.it/4')
    .addPlugin(RavenVue, Vue)
    .install()
}

smoothscroll.polyfill()

Vue.use(VueQuammServices)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
